<template>
	<!-- 咨询建议-需求咨询 详情与编辑 弹窗开始 -->
	<div class="detailWap" id="view01">
	  <div class="rightWap" >
	    <div class="message" v-loading="loadingMask">
	      <h1>详情<img src="/images/rightClose.png" class="closePop1" @click="closeFloat"/></h1> 
	      <dl class="messageForm">
	        <dt>咨询内容</dt>
	        <dd>
	          <div class="textareaWap">
							<textarea id="aa1" rows="8" v-model="zixunform.desc" maxlength="300" style="resize: none;" :readonly="!isedit"></textarea>
						</div>
	          <span style="position: absolute; right: 24px; bottom: 24px; display: none;" id="t1">{{zixunform.desc.length}}/300</span>
	        </dd>
	        <dt>邮箱</dt>
	        <dd><input type="text" v-model="zixunform.email" :readonly="!isedit" id="aa2"/></dd>
	        <dt>联系电话</dt>
	        <dd><input type="text" v-model="zixunform.phone" :readonly="!isedit" id="aa3"/></dd>
	      </dl>
	      <div style="text-align: right">
	        <input type="button" value="修改" v-if="!isedit"  @click="isedit=1" class="messageSub" id="edit01"/>
	        <input type="button" value="保存" v-else  @click="updatezixun" class="messageSub" id="save01"/>
	      </div>  
	    </div>
	  </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask:true,
				isedit:0,
				zixunDetail:'',
				zixunform: {
					desc: '',
					email:'',
					phone:''
				},
			}
		},
		props:[
			'detailid'
		],
		mounted: function() {
			this.getZixunDetailfnc();
			this.$track([
				['pagetype','查看需求咨询']
			]);
		},
		methods: {
			getZixunDetailfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/GetUserFeedback',
						responseType: 'json',
						params: {
							id: this.detailid,
						},
					})
					.then(function(response) {
						_this.zixunDetail = response.data.data.data.feedback;
						var zixunContent= JSON.parse(_this.zixunDetail.content);
						_this.zixunform.desc=zixunContent.desc;
						_this.zixunform.email=zixunContent.email;
						_this.zixunform.phone=zixunContent.phone;
						_this.$track([
							['pagetype','查看资料需求详情']
						]);
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			updatezixun:function(){
				if(!this.zixunform.desc){
					this.$message({
						message: '请填写描述',
						type: 'warning'
					});
					
					return false;
				}
				else if (!this.zixunform.email){
					this.$message({
						message: '请填写邮箱',
						type: 'warning'
					});
					
					return false;
				}
				
				if(this.zixunform.email){
					var regemail=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if(!regemail.test(this.zixunform.email)){
						this.$message({
							message: '请正确填写邮箱',
							type: 'warning'
						});
						return false;
					}
				}
				
				if(this.zixunform.phone){
					var regmobile=/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					var regtel=/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
					if((!regmobile.test(this.zixunform.phone))&&(!regtel.test(this.zixunform.phone))){
						this.$message({
							message: '请填写正确的联系电话,固定电话请添加区号',
							type: 'warning'
						});
						return false;
					}
				}
				
				var tempzixun={
					desc:this.zixunform.desc,
					email:this.zixunform.email,
					phone:this.zixunform.phone
				}
				let _this = this;
				this.$http({
						method: 'post',
						url: 'UserInfo/UpdateUserFeedback',
						responseType: 'json',
						params: {
							id:this.detailid,
							content: JSON.stringify(tempzixun)
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: '需求咨询修改成功',
								type: 'success'
							});
							_this.zixunform.desc='';
							_this.zixunform.email='';
							_this.zixunform.phone='';
							_this.closeFloat();
							_this.$track([
								['pagetype','修改资料需求']
							]);
						}
						else{
							_this.$message({
								message: '需求咨询修改失败',
								type: 'error'
							});
						}
						
					})
					.catch(function(error) {
						_this.$message({
							message: '需求咨询修改失败',
							type: 'error'
						});
						// _this.closeFloat();
						console.log(error);
					});
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			
		},
	}
</script>

<style>
</style>
